import type { SVGProps } from 'react';

type LoopSpinnerProps = SVGProps<SVGSVGElement> & {
  backgroundColor?: string;
  arrowColor?: string;
};

const LoopSpinner = ({ backgroundColor = '#FF0085', arrowColor = '#FFF', ...rest }: LoopSpinnerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox={`0 0 80 80`} {...rest}>
    <defs>
      <path id="a" d="M40 0C17.778 0 0 17.778 0 40s17.778 40 40 40 40-17.778 40-40S62.222 0 40 0Z" />
    </defs>
    <g fill="none" fillRule="nonzero">
      <use xlinkHref="#a" fill={backgroundColor} />
      <path
        fill={arrowColor}
        d="M26.484 36.952c.391 0 .651-.234.782-.599.442-1.041.755-2.03 1.38-3.046A13.293 13.293 0 0 1 40 26.952c3.36 0 6.615 1.276 9.089 3.568l-3.594 3.594c-.313.312-.495.729-.495 1.172 0 .911.755 1.666 1.667 1.666h11.666c.912 0 1.667-.755 1.667-1.666V23.619c0-.911-.755-1.667-1.667-1.667-.442 0-.859.183-1.172.495l-3.385 3.36c-3.698-3.49-8.672-5.521-13.776-5.521-9.61 0-17.292 6.406-19.531 15.65v.183a.84.84 0 0 0 .833.833h5.182Zm13.412 23.334c9.61 0 17.213-6.433 19.427-15.651.026-.052.026-.13.026-.183a.84.84 0 0 0-.833-.833h-5c-.391 0-.651.234-.782.599-.442 1.042-.755 2.031-1.38 3.047A13.293 13.293 0 0 1 40 53.619c-3.36 0-6.615-1.302-9.063-3.594l3.568-3.567c.313-.313.495-.73.495-1.172 0-.912-.755-1.667-1.667-1.667H21.667c-.912 0-1.667.755-1.667 1.667v11.666c0 .912.755 1.667 1.667 1.667.442 0 .859-.182 1.172-.495l3.359-3.36c3.698 3.516 8.62 5.522 13.698 5.522Z"
      />
    </g>
  </svg>
);
export default LoopSpinner;
